






























import { Component, Vue } from 'vue-property-decorator'
import { State, namespace } from 'vuex-class'
import share from '$utils/act-share'
import { ACT_CODE } from '$services/free-order'

import Marquee from '$components/marquee'
import Game from './game.vue'
import Banners from './banners.vue'
import RedPacket from './red-packet.vue'
import PrizeDialog from './prize-dialog.vue'
import TaskList from './task-list.vue'
import FloatBall from './float-ball.vue'
import StayPop from './_components/stay-pop.vue'
import RulePop from './_components/rule-pop.vue'
import FireFly from './fire-fly.vue'
import FreeOrder from './free-order.vue'

const actModule = namespace('freeOrder')

@Component({
  name: 'index',
  components: {
    Marquee,
    Game,
    Banners,
    RedPacket,
    PrizeDialog,
    TaskList,
    FloatBall,
    StayPop,
    RulePop,
    FireFly,
    FreeOrder
  }
})
export default class Index extends Vue {
  @State(state => state.common.loginState) isLogin!: boolean
  @actModule.Getter actConfig!: any
  @actModule.Getter actEnd!: any
  @actModule.Getter bookFlag!: any
  @actModule.Getter isShowGuide!: any
  finish = false
  rulePopup = false
  ACT_CODE= ACT_CODE
  noData = false
  // 显示规则
  showRule() {
    this.$Collect.trackEvent('2020双12火力红包页面_规则_点击')
    this.rulePopup = true
  }
  // 分享
  share() {
    this.$Collect.trackEvent('2020双12火力红包页面_分享_点击')
    share()
  }
  // 关闭新人引导
  closeGuide() {
    this.$Collect.trackEvent('2020双12新人引导页_点击任意处')
    this.$store.commit('freeOrder/updateIsShowGuide', false)
  }
  noFreeOrderData() {
    this.noData = true
  }
  // 重新回到页面处理方法
  visibilityHandler() {
    if (document.visibilityState === 'visible') {
      // 延迟1秒更新状态
      setTimeout(() => {
        console.log('记一笔来源', this.bookFlag)
        // 记一笔来源
        if (this.bookFlag) {
          // 由于服务端存在异常更新任务的原因，这里延迟4秒更新状态
          setTimeout(() => {
            this.$store.dispatch('freeOrder/bootstrap', { force: true })
          }, 4000)
          this.$store.commit('freeOrder/updateBookFlag', false)
        } else {
          this.$store.dispatch('freeOrder/bootstrap', { force: true })
        }
      }, 1000)
    }
  }
  mounted() {
    this.$Collect.init({
      baidu: false, // 是否引入百度统计代码！默认引入，不引入可以配置为false
      ga: false, // 是否引入GA统计代码！默认引入，不引入可以配置为false
      flowName: 'fuwu_shenghuo', // 默认值是‘finance’，一般情况下不需要修改
      pageName: '2020双12火力红包页面', // 页面标题，例如基金首页，可以配置为“基金首页”
    })
    this.$Collect.trackView('2020双12火力红包页面_浏览')
    this.$store.dispatch('freeOrder/bootstrap')
    document.addEventListener('visibilitychange', this.visibilityHandler)
    // this.$store.commit('freeOrder/updateRunConf', {
    //   run: true,
    //   uiComponentCode: 'xxx',
    //   ruleGroupCode: '666',
    // })
    // setTimeout(() => {
    //   this.$store.commit('freeOrder/updateFireXYZ', {
    //     x: 200,
    //     y: 600
    //   })
    // }, 4000)
  }
  destroyed() {
    document.removeEventListener('visibilitychange', this.visibilityHandler)
  }
}
